import React from 'react';
import { ScaleBarProps } from 'business/models/CustomModels';
import { Rect, Text, Group, Line } from 'react-konva';

export default function ScaleBarRenderer(props: ScaleBarProps) {
  const x = props.x + 10 / props.scale;
  const scaleBarPerToHeight = 0.25;
  const scaleBarStartingXPerToWidth = 0.1;
  const scaleBarLeftMargin = props.width * scaleBarStartingXPerToWidth;
  const scaleBarRectX = x + scaleBarLeftMargin;
  const scaleBarRectY =
    props.y + props.height / 2 - (props.height * scaleBarPerToHeight) / 2;
  const scaleBarWidth = props.scaleBarWidth;
  const scaleBarHeight = props.scaleBarHeight;
  return (
    <Group id={`scalebarrenderer-${props.text}-group`}>
      <Rect
        id={`scalebarrenderer-${props.text}-rect-1`}
        x={x}
        y={props.y}
        width={props.width}
        height={props.height}
        fill="#787a7c"
        opacity={0.6}
      />
      <Rect
        id={`scalebarrenderer-${props.text}-rect-2`}
        x={props.x}
        y={props.y}
        width={10 / props.scale}
        height={props.height}
        borderRadius={3}
        fill="#787a7c"
        opacity={0.8}
      />
      <Line
        id={`scalebarrenderer-${props.text}-line`}
        points={[
          props.x + 5 / props.scale,
          props.y,
          props.x + 5 / props.scale,
          props.y + props.height,
        ]}
        stroke={'black'}
        dash={[2 / props.scale, 2 / props.scale]}
        strokeWidth={2 / props.scale}
        opacity={0.8}
      />
      <Rect
        id={`scalebarrenderer-${props.text}-rect-3`}
        x={scaleBarRectX - 3 / props.scale}
        y={scaleBarRectY - 3 / props.scale}
        width={3 / props.scale}
        height={scaleBarHeight + 6 / props.scale}
        borderRadius={3}
        fill="white"
        opacity={1}
      />
      <Rect
        id={`scalebarrenderer-${props.text}-rect-4`}
        x={scaleBarRectX}
        y={scaleBarRectY}
        width={scaleBarWidth}
        height={scaleBarHeight}
        fill="white"
        opacity={1}
      />
      <Rect
        id={`scalebarrenderer-${props.text}-rect-5`}
        x={scaleBarRectX}
        y={scaleBarRectY}
        width={scaleBarWidth}
        height={scaleBarHeight}
        fill="white"
        opacity={1}
      />
      <Text
        id={`scalebarrenderer-${props.text}-text`}
        x={x + scaleBarWidth + scaleBarLeftMargin * 2}
        y={props.y}
        height={props.height}
        fontSize={props.fontSize}
        verticalAlign="middle"
        align="center"
        textAnchor="middle"
        text={props.text}
        fill="white"
        opacity={0.8}
      />
      <Rect
        id={`scalebarrenderer-${props.text}-rect-6`}
        x={scaleBarRectX + scaleBarWidth}
        y={scaleBarRectY - 3 / props.scale}
        width={3 / props.scale}
        height={scaleBarHeight + 6 / props.scale}
        borderRadius={3}
        fill="white"
        opacity={1}
      />
    </Group>
  );
}
